/* eslint-disable */
import React, { useState, useRef, useEffect } from "react"
import { css } from "@jsUtils"
import Styles from "./TechnologyScrollSection.module.scss"

let ctx

Number.prototype.clamp = function(min, max) {
  return Math.min(Math.max(this, min), max)
}

const usePrevious = value => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

const TechnologyScrollSection = props => {
  const {
    currentScroll,
    sequences,
    direction,
    sections,
    currentSection,
    nextSection,
    prevSection,
    sticky
  } = props
  const [mounted, setMounted] = useState(false)
  const [mode, setMode] = useState("scroll")
  const [currentPercent, setCurrentPercent] = useState(0)
  const [currentAsset, setCurrentAsset] = useState(null)
  const canvasRef = useRef()
  const videoRef = useRef([])
  const componentRef = useRef()
  const lastSection = usePrevious(currentSection)

  const resize = () => {
    const canvas = canvasRef.current
    canvas.width = 1920
    canvas.height = 1080
  }
  useEffect(() => {
    if (!mounted && sections.length > 0) {
      ctx = canvasRef.current.getContext("2d")

      resize()
      setMounted(true)
    }
  }, [mounted, sections])

  useEffect(() => {
    if (sections.length > 0) {
      let _currentSection = sections[currentSection]
      setCurrentAsset(_currentSection.asset)
      setMode(_currentSection.type)
    }
  }, [currentSection, sections])

  useEffect(() => {
    if (sequences.length > 0 && ctx) {
      const _currentSection = sections[currentSection]
      const _sequence = sequences[_currentSection.asset]
      const _start = _currentSection.start || 0
      const _mode = _currentSection.type

      if (_mode === "sequence" && _sequence) {
        const canvas = canvasRef.current
        const _frames = Math.abs(_start) / _sequence.length
        let _frame = 0
        if (_start > 0) {
          _frame = currentPercent > _start ? (currentPercent - _start) / _frames : 0
        } else {
          _frame = currentPercent > 0 ? currentPercent / _frames : 0
        }
        const _asset = _sequence[Math.round(_frame.clamp(0, _sequence.length - 1))].asset
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        ctx.drawImage(_asset, 0, 0, canvas.width, canvas.height)
      } else {
        if (currentSection != lastSection && videoRef.current[currentSection]) {
          videoRef.current[currentSection].currentTime = 0
          setTimeout(() => {
            if (direction == "down") {
              videoRef.current[currentSection].play()
            }
            if (direction == "up") {
              videoRef.current[currentSection].currentTime =
                videoRef.current[currentSection].duration
            }
          }, 0)
        }
      }

      if (_currentSection.out == "fade") {
        if (currentPercent > 0) {
          componentRef.current.style.opacity = 1 - ((100 + currentPercent) / 100 - 1).clamp(0, 1)
          componentRef.current.style.transition = "0s"
          // componentRef.current.style.zIndex = -1
        } else {
          componentRef.current.style = null
        }
      }
    }
  }, [currentPercent, sequences, currentSection, direction])

  const createVideo = section => {
    return (
      <video
        key={section.index}
        src={section.asset}
        ref={r => (videoRef.current[section.index] = r)}
        playsInline
        muted
        className={css(
          Styles.techVideo,
          mode == "video" && currentSection == section.index && Styles.active
        )}
        loop={section.loop}
      ></video>
    )
  }

  useEffect(() => {
    if (sections.length > 0) {
      let _currentSection = sections[currentSection]
      let _scrollPos =
        _currentSection.bounds.height +
        _currentSection.bounds.top -
        currentScroll -
        window.innerHeight / 2
      let _percent = 100 - (_scrollPos / _currentSection.bounds.height) * 100
      setCurrentPercent(_percent)
    }
  }, [currentScroll])

  useEffect(() => {
    if (!sticky) {
      componentRef.current.style.top = `${currentScroll}px`
    } else {
      componentRef.current.style.top = "0px"
    }
  }, [sticky])

  const _nextSection = sections[nextSection]
  const _prevSection = sections[prevSection]

  return (
    <div className={css(Styles.component, sticky && Styles.sticky)} ref={componentRef}>
      <canvas
        ref={canvasRef}
        className={css(Styles.techCanvas, mode == "sequence" && Styles.active)}
      ></canvas>
      {sections.map(section => section.type == "video" && createVideo(section))}
    </div>
  )
}

export default TechnologyScrollSection
